export function truncateString(str, maxLength) {
  if (str?.length <= maxLength) {
    return str
  }

  let ellipsis = '...'
  let truncatedLength = maxLength - ellipsis?.length
  let leftLength = Math.ceil(truncatedLength / 2)

  let leftSubstring = str?.substring(0, leftLength)
  let rightSubstring = str?.substring(str.length - 4)

  return leftSubstring + ellipsis + rightSubstring
}
